export const APP_ROUTES = {

    LOGIN: '/',
    DASHBOARD: '/dashboard',
    RECEIVEDORDERS: '/receivedOrders',
    ALLORDERS: '/allOrders',
    REPORTS: '/reports',
    COMPLETEDORDERS: '/completedOrders',
    PENDINGORDERS: '/pendingOrders',
    LABLIST: '/lablist',
    COLLECTION: '/collection',
    MAPLIST: '/cheMapping',
    MOBIUSERLIST: '/mapUserList',
    HOMECC: '/homeCollection',
    D2CORDERS: '/d2cOrders',
    CCBULK: '/ccBulk',
    FORGET: '/userforgetpassword',
    MOBILABECLIST:'/mobilabeclinicList',
    MOBIUSERNEW: "/mobiusernew",
    TRACKING : "/tracking",
    LOG : "/erroLog",
    REPORTFAIL:"/reportFail",
    ONBARDING :"/onboarding",
    LABONBOARD:"/labOnboarding",
    CCONBOARDLIST:"/onboardingList",
    BUSINESSAPPROVAL:"/businessApproval",
    FINANCEAPPROVAL:"/financeApproval",
    CONFIGURATION:"/configuration",
    CORPORATELIST:"/corporateList",
    CORPORATEAPPROVAL:"/corporateApproval"

}